module.exports = __webpack_public_path__ + "membership.svg?5e95073704c4c2c9894886c6e7fec341";